export const en = {
    'buttons': {
        'return': 'Return',
        'main': 'Main'
    },
    'selects': {
        'currency': {
            'label': 'Currency',
            'placeholder': 'Choose currency',
            'options-title': 'List of available coins'
        },
        'currency-and-network': {
            'placeholder': 'Choose currency and network',
            'options-title': 'List of available coins'
        },
        'selected-label': 'Selected: {selected} of {length}',
        'search': 'Search',
        'errors': {
            'invalid': 'Invalid value',
            'required': 'Required',
            'card-holder': "Enter the cardholder's first and last name",
            'input-amount': "Enter amount",
            'fill-card': "Fill in the card details"
        },
        'empty-list': 'Empty list',
        'address': {
            'label': 'Withdrawal address in {currency}',
            'options-title': 'List of available addresses',
            'placeholder': 'Choose address'
        },
        'cardholder-input': {
            'placeholder': 'Card Holder'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Your address for deposit'
            },
            'invoice': {
                'address': 'Address',
                'paid-amount': 'Paid amount',
                'amount-to-pay': 'Amount to pay',
            }
        }
    },
    'labels': {
        'deposit': 'Deposit',
        'withdraw': 'Withdraw',
        'currency': 'Currency',
        'amount': 'Amount',
        'language': 'Language',
        'russian': 'Russian',
        'english': 'English',
        'theme': 'Theme',
        'dark': 'Dark',
        'light': 'Light',
        'view': 'View',
        'cookie-policy': {
            'label': 'Cookie policy',
            'open-policy': 'Open policy'
        },
        'invoice': {
            'remaining-time': 'Remaining time to pay',
            'status': {
                'expires': 'Time is over',
                'success': 'Payment Successful',
                'error': 'Error'
            },
            'partially-paid': {
                'title': 'Partially paid',
                'info': 'The amount has been partially paid. The remaining amount ust be paid for successful payment.'
            },
            'orphan': {
                'title': 'Orphan transaction',
                'description': 'One of the transactions on this order contains the wrong network or currency.',
                'contact': 'Contact technical support with ID:'
            },
            'you-paid': 'You paid',
            'active-order': 'Active order',
            'new-invoice': 'New invoice',
            'order-id': 'Order ID',
            'payment-id': 'Invoice ID',
            'description': 'Description',
            'payment-amount': 'Payment amount',
            'rate': 'Exchange rate',
            'remaining-amount': 'Remaining amount'
        },
        'continue': 'Continue',
        'payout': {
            'address': 'Withdrawal address in {currency}',
            'tag-or-memo': 'TAG or MEMO',
            'status': {
                'processed': 'Successfull',
                'error': 'Error',
                'orphan': 'Orphan transaction',
                'approve_rejected': 'Rejected',
                'in-progress': 'In progress',
                'need-approve': 'Need Approve',
                'awaiting-confirmation': 'Your withdrawal request is awaiting confirmation'
            },
            'info': {
                'withdraw-id': 'Withdrawal ID',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Currency and network',
                'address': 'Address',
                'tag-or-memo': 'TAG or MEMO',
                'amount': 'Amount',
                'rate': 'Rate',
                'blockchain-fee': 'Blockchain fee'
            }
        },
        'fiat': {
            'title': 'Deposit via fiat',
            'info': {
                'amount': 'Amount',
                'date': 'Payment date',
                'id': 'Deposit ID',
                'system': 'Payment system'
            },
            'status': {
                'new': 'New',
                'pending': 'Pending',
                'authorized': 'Authorized',
                'confirmed': 'Confirmed',
                'reconciled': 'Reconciled',
                'error': 'Error',
                'declined': 'Declined'
            },
            'payment-id': 'Payment ID',
        },
        'information': 'Information'
    },
    'errors': {
        'wrong-widget-id': 'Wrong widget ID',
        'wrong-ext-user-id': 'Wrong external user ID',
        '404': "Oops! We searched but didn't find what you're looking for.",
        'without-xt-user-id-withdrawal': "Withdrawal unavailable. The extUserId parameter is not passed",
        'without-xt-user-id-deposit': "Deposit unavailable. The extUserId parameter is not passed",
        'amount': "The amount must be more than the network's commission"
    },
    'invoice': {
        'order': 'Order',
        'inputs': {
            'email': {
                'label': 'E-mail address',
                'placeholder': 'Enter your e-mail address'
            },
            'amount': {
                'label': 'Amount',
                'placeholder': 'Enter amount'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Amount in',
                'rate': 'Exchange rate',
                'payment-id': 'Payment ID',
                'description': 'Description'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Do not refresh the page or open the invoice in a',
            'new-tab': 'new tab'
        },
        'statuses': {
            'ERROR': 'ERROR',
            'PENDING': 'PENDING',
            'PROCESSED': 'PROCESSED',
            'REJECTED': 'REJECTED',
            'OVERPAID': 'OVERPAID',
            'CREATED': 'CREATED',
            'PARTIAL': 'PARTIAL PAID',
            'INIT': 'INIT',
            'EXPIRED': 'EXPIRED',
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Deposit',
            'payment-history': 'History',
            'payment-history-small': 'Payment history'
        },
        'payment-history': {
            'empty-label': 'All your transactions sent to the specified address will be available here',
            'headers': {
                'date': 'Date and Time',
                'amount': 'Amount',
                'tx': 'Tx_hash',
                'status': 'Status'
            },
            'statuses': {
                'orphan': 'Orphan',
                'processed': 'Processed',
                'pending': 'Pending',
                'rejected': 'Rejected',
                'error': 'Error'
            },
            'in': 'in'
        },
        'qr-block': {
            'empty-label': 'Deposit replenishment using cryptocurrency',
            'qr-info-pre-invoice': 'Only send',
            'qr-info-pre-personal': 'Send any amount only in',
            'qr-info-post': 'to this address',
            'qr-info-minimal': 'Transfers of less than 1 USD will not be credited'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Deposit via fiat',
            'payment-history': 'Payment history'
        },
        'labels': {
            'pay': 'Pay',
            'service-commission': 'Service commission amount',
            'total': 'Total',
            'you-pay': 'You pay'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Orphan transaction',
            'info': 'One of the transactions on this order contains the wrong network or currency.',
            'support': 'Contact technical support with ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'By clicking the “Continue” button, you automatically agree to',
        'our': 'our cookie policy'
    },
    'payout': {
        'payout': 'Payout',
        'output': 'Withdraw',
        'withdraw': 'Withdraw',
        'errors': {
            'wrong-address': `The address is not on the {network} network`
        }
    }
}